import { FormikDatePicker } from '@/components/form/fields/FormikDatePicker/FormikDatePicker';
import { Box } from '@/components/Box/Box';

export type RangeDatePickerType = {
  nameStart: string;
  nameEnd: string;
  dateStart: Date;
  dateEnd: Date;
};

export const FormikRangeDatePicker = ({ nameStart, nameEnd, dateStart, dateEnd }: RangeDatePickerType) => {
  return (
    <Box flexDirection='row' columnGap='10px' mobile={{ width: '100%' }}>
      <Box mobile={{ flex: 1 }}>
        <FormikDatePicker
          name={nameStart}
          variant='small'
          isClearable={false}
          selectsStart
          startDate={dateStart}
          endDate={dateEnd}
        />
      </Box>
      <Box mobile={{ flex: 1 }}>
        <FormikDatePicker
          name={nameEnd}
          variant='small'
          isClearable={false}
          selectsEnd
          startDate={dateStart}
          endDate={dateEnd}
          minDate={dateStart}
        />
      </Box>
    </Box>
  );
};
